export default __webpack_public_path__ + "static/media/Circle03.804fa609.svg";